// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../app/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".form-fields{margin-left:1.3rem;margin-bottom:1rem}", "",{"version":3,"sources":["/workspace/app/javascript/account-app/features/campaigns/payment-information-section.styles.scss"],"names":[],"mappings":"AAEA,aACE,kBAAA,CACA,kBAAA","file":"payment-information-section.styles.scss","sourcesContent":["@import \"app/assets/stylesheets/v2/framework/core\";\n\n.form-fields {\n  margin-left: 1.3rem;\n  margin-bottom: 1rem;\n}\n"]}]);
// Exports
module.exports = exports;
